import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { HttpCssClient } from '../shared/http-request.interceptor';
import { BasketSettings } from '../settings/basket.settings';


@Injectable()
export class BasketService{
    constructor(private http:HttpCssClient){}
    getCurrentBasket():Observable<Object[]>{
        let url = BasketSettings.GET_BASKET;
        return this.http.post(url,{}).pipe(map(function(response:Response){
            let body;
            if(response.status == 200){
                body = response.body;
            }
            return body;
        }));
    }

    deleteFromBasket(sale):Observable<any>{
        let url = BasketSettings.DELETE_BASKET;
        return this.http.post(url,sale).pipe(map((response:HttpResponse<any>)=>{
            let token = response.headers.get("authorization");
            let body = response.body;
            if(token != null){
                this.http.addHeader("Authorization",token);
            }else{
                this.http.removeHeader("Authorization");
            }

            return <any>{response: body, token: token };
        }));
    }

    useCoupon(code:string, sales:Object[]):Observable<any>{
        let url = BasketSettings.APPLY_COUPON;
        let couponReady = {couponCode:code, listSaleDTO:sales};
        return this.http.post(url,couponReady).pipe(map((response:Response) => {
            let body = response.body;
            return body;
        }));
    }
}